import {
  applyMiddleware,
  createStore
} from "redux";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";
import { composeWithDevTools } from "redux-devtools-extension";

import { Reducers } from "state/Reducers";
import { InitialState } from "state/InitialState";

// ----------------------------------------------------------------------

/*
const persistConfig = {
  key: "glambox",
  stateReconciler: hardSet,
  storage
};
*/

//const persistedReducer = persistReducer(persistConfig, Reducers);

// ----------------------------------------------------------------------

const middleware = [
  thunk
];

if (process.env.NODE_ENV !== "production") {
  //middleware.push(createLogger());
}

const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 });

// ----------------------------------------------------------------------

export const Store = createStore(
  //persistedReducer,
  Reducers, 
  InitialState.create(),
  composeEnhancers(
    applyMiddleware(...middleware)
  )
);

//export const PersistedStore = persistStore(Store);
